import React from 'react';

export const Cosult_Text = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    renderContent: () => <span>CONSULTA</span>,
  },
];

export const Create_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    renderContent: () => <span>CREA CON NOSOTROS</span>,
  },
];

export const Join_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    renderContent: () => <span>ÚNETE AL EQUIPO</span>,
  },
];

export const Practice_Text = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    renderContent: () => <span>PRÁCTICAS / SERVICIO SOCIAL</span>,
  },
];
